"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _FiltersModule = _interopRequireDefault(require("../../styles/components/Filters.module.css"));
var _material = require("@mui/material");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ButtonField = _ref => {
  let {
    filter,
    updateActiveFilter,
    isIncludes
  } = _ref;
  return (0, _react.useMemo)(() => {
    const {
      showIf = true,
      id,
      value = '',
      name = '',
      text = '',
      type = '',
      grouped = false
    } = filter;
    return /*#__PURE__*/_react.default.createElement("div", {
      key: id,
      className: "".concat(_FiltersModule.default.filter_btn_wrap, " ").concat(showIf ? '' : _FiltersModule.default.hide_filter)
    }, /*#__PURE__*/_react.default.createElement(_material.Button, {
      variant: "outlined",
      className: "".concat(_FiltersModule.default.filter_btn, " ").concat(isIncludes({
        name,
        type,
        grouped,
        value
      }) ? _FiltersModule.default.active_btn : ''),
      onClick: () => updateActiveFilter({
        name,
        type,
        value,
        grouped
      })
    }, text));
  }, [filter, isIncludes]);
};
var _default = exports.default = ButtonField;